module.exports = __webpack_public_path__ + "static/media/PJansche_Lehrer.fe1aad65.JPG";